import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  Category,
  ClientDTO,
  TTMap,
  SearchByOptions
} from 'src/store/workspace/workspace.model';
import {
  Observable,
  Subscription,
  combineLatest
} from 'rxjs';
import {
  Store
} from '@ngrx/store';
import * as fromRoot from 'src/store';
import * as fromWorkspace from 'src/store/workspace';
import {
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';
import {
  GridComponent,
  PagerSettings,
  PageChangeEvent
} from '@progress/kendo-angular-grid';
import {
  isNumber, cloneDeep
} from 'lodash';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
  gridData$: Observable < [Category[], number | 'all', SearchByOptions] > ;
  gridData: Category[];
  gridSubs: Subscription;

  categories: Category[];
  allCategories: Category[];

  clients$: Observable < TTMap < ClientDTO >> ;
  clientsMap: TTMap < ClientDTO > ;
  clientsSubs: Subscription;
  clients: ClientDTO[];

  editedRowIndex: number;
  formGroup: FormGroup;

  public pageSize: number | 'all' = 'all';
  public skip = 0;
  public length: number;
  public pageable: PagerSettings = {
    pageSizes: true,
    previousNext: true,
    info: true
  };
  public pageSizes: any[] = [10, 20, 30, 40, 50, {
    text: 'All',
    value: 'all'
  }];

  public sort: SortDescriptor[];
  public sortable = {
    allowUnsort: true,
    mode: 'single'
  };

  @ViewChild('grid', {
    static: false
  }) grid: GridComponent;

  public columns: any[] = [{
      field: 'categoryID',
      hidden: true
    },
    {
      field: 'clientName',
      title: 'Client Name',
    },
    {
      field: 'category',
      title: 'Category'
    },
  ];
  constructor(private store: Store < fromRoot.AppState > , private formBuilder: FormBuilder) {
    this.store.dispatch(new fromWorkspace.LoadCategories());
    this.store.dispatch(new fromWorkspace.LoadCategoriesPageSize());
    this.sort = [];
    this.gridData$ = combineLatest(
      this.store.select(state => Object.values(state.workspace.categories)),
      this.store.select(state => state.workspace.categoriesPageSize),
      this.store.select(state => state.workspace.searchByOptions)
    );
    this.clients$ = this.store.select(state => state.workspace.clients);
    this.clientsSubs = this.clients$.subscribe(clients => {
      this.clientsMap = clients;
      this.clients = Object.values(clients).sort((a, b) => {
        if (a.clientName.toLowerCase() > b.clientName.toLowerCase()) {
          return 1;
        }
        if (a.clientName.toLowerCase() < b.clientName.toLowerCase()) {
          return -1;
        }
        return 0;
      }).filter(client => client.active && client.categorizeBilling);
    });
    this.gridSubs = this.gridData$.subscribe(([categories, pageSize, searchByOptions]) => {
      if (this.grid && categories.length !== this.allCategories.length) {
        this.closeEditor(this.grid);
      }
      if (searchByOptions.client && searchByOptions.client.clientID) {
        categories = categories.filter(cat => cat.clientID === searchByOptions.client.clientID);
      }
      categories = categories.map(c => {
        const cat = cloneDeep(c);
        cat.clientName = this.clientsMap[cat.clientID].clientName;
        return cat;
      });
      categories = orderBy(categories, this.sort);
      this.length = categories.length;
      this.pageSize = pageSize;
      if (!isNumber(pageSize) && this.length) {
        this.pageSize = this.length || 10;
      }
      this.allCategories = categories;
      const size = this.pageSize as number;
      this.gridData = categories.slice(this.skip, this.skip + size);
    });
    this.store.dispatch(new fromWorkspace.LoadCategoriesPageSize());
    this.store.select(state => state.workspace.categoriesPageSize).subscribe(size => {
      this.pageSize = size;
    });
  }

  ngOnInit() {}

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.store.dispatch(new fromWorkspace.LoadCategories());
  }

  public cancelHandler({
    sender,
    rowIndex
  }) {
    this.closeEditor(sender, rowIndex);
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    let pageSize: number | 'all' = event.take;
    if (pageSize === this.length) {
      pageSize = 'all';
    }

    this.store.dispatch(new fromWorkspace.SetCategoriesPageSize(pageSize));
    this.store.dispatch(new fromWorkspace.LoadCategories());
  }


  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  public addHandler({
    sender
  }) {
    this.closeEditor(sender);
    const c: Category = {
      categoryID: null,
      category: null,
      clientID: null,
    };
    this.formGroup = this.createFormGroup(c);

    sender.addRow(this.formGroup);
  }

  public createFormGroup(dataItem: Category): FormGroup {
    return this.formBuilder.group({
      categoryID: [dataItem.categoryID],
      category: [dataItem.category, Validators.required],
      clientID: [dataItem.clientID, Validators.required],
    });
  }
  public saveHandler({
    rowIndex,
    formGroup
  }): void {
    this.store.dispatch(new fromWorkspace.AddCategory(formGroup.value));
    this.grid.closeRow(rowIndex);
  }
}
